import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CotService {
  private url = environment.api;
  constructor(
    private http:HttpClient
  ) { }

  getCotizaciones() {
    return this.http.get(this.url + "api/erp/sale/invoices/prices");
  }  
  getOverdueCotizaciones(startDate: string, endDate: string) {
    return this.http.get(this.url + "api/erp/sale/invoices/prices-overdue/" + startDate + "/" + endDate);
  }

  factCot(idCot: number) {
    return this.http.put(this.url + "api/erp/sale/invoices/factPrice/"+idCot, null);
  }  

  factCotCash(idCot: number, idCash: any) {
    const params = new HttpParams().set('cashAcc', idCash);
    return this.http.put(
      `${this.url}api/erp/sale/invoices/factPrice/${idCot}`,
      null,
      { params }
    );
  }

  deleteCot(idCot: number) {
    return this.http.put(this.url + "api/erp/sale/invoices/disposePrice/" + idCot, null);
  }
}